function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M591.842 400.771L71.8425 385.871C47.6425 385.171 27.7425 366.671 25.3425 342.571L0.24249 94.571C-2.55751 66.471 19.2425 41.971 47.4425 41.571L626.242 33.571C655.442 33.171 678.342 58.671 674.742 87.671L641.042 358.571C637.942 383.171 616.642 401.471 591.842 400.771Z",
  fill: "#D2E0F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M591.842 400.771L71.8425 385.871C47.6425 385.171 27.7425 366.671 25.3425 342.571L0.24249 94.571C-2.55751 66.471 19.2425 41.971 47.4425 41.571L626.242 33.571C655.442 33.171 678.342 58.671 674.742 87.671L641.042 358.571C637.942 383.171 616.642 401.471 591.842 400.771Z",
  fill: "#EAF9F3"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_421_16)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M436.143 412.571L437.943 453.071C437.943 461.371 431.243 468.071 422.943 468.071H7.34253C-0.957471 468.071 -7.65747 461.371 -7.65747 453.071V217.371C-7.65747 209.071 -0.957471 202.371 7.34253 202.371H422.843C431.143 202.371 437.843 209.071 437.843 217.371V376.771",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M529.243 377.771V145.671C529.243 137.371 535.943 130.671 544.243 130.671H668.243C676.543 130.671 683.243 137.371 683.243 145.671V489.971C683.243 498.271 676.543 504.971 668.243 504.971H544.243C535.943 504.971 529.243 498.271 529.243 489.971V415.071",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.4425 132.071H-4.45752V123.171H85.4425C86.4425 123.171 87.2425 123.971 87.2425 124.971V130.171C87.3425 131.171 86.5425 132.071 85.4425 132.071Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.7425 202.371H51.4425C49.2425 202.371 47.4425 200.771 47.1425 198.571L45.5425 184.171C45.2425 181.671 47.2425 179.371 49.8425 179.371H73.3425C75.9425 179.371 77.8425 181.571 77.6425 184.171L76.0425 198.571C75.8425 200.771 73.9425 202.371 71.7425 202.371Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.2426 179.471C59.2426 179.471 51.2426 178.671 49.6426 167.871C49.6426 167.871 56.8426 169.971 59.1426 175.071C59.1426 175.071 60.1426 163.671 65.5426 162.571C65.5426 162.571 67.9426 171.071 64.1426 175.271C64.1426 175.271 67.0426 170.471 74.4426 170.571C74.4426 170.571 72.5426 177.371 65.2426 179.371",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.843 130.671H597.543C595.343 130.671 593.543 129.071 593.243 126.871L591.643 112.471C591.343 109.971 593.343 107.671 595.943 107.671H619.443C622.043 107.671 623.943 109.871 623.743 112.471L622.143 126.871C621.843 129.071 620.043 130.671 617.843 130.671Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.243 107.771C605.243 107.771 597.243 106.971 595.643 96.171C595.643 96.171 602.843 98.271 605.143 103.371C605.143 103.371 606.143 91.971 611.543 90.871C611.543 90.871 613.943 99.371 610.143 103.571C610.143 103.571 613.043 98.771 620.443 98.871C620.443 98.871 618.543 105.671 611.243 107.671",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.743 252.071H329.543C327.243 252.071 325.343 250.171 325.343 247.871V220.471C325.343 218.171 327.243 216.271 329.543 216.271H419.743C422.043 216.271 423.943 218.171 423.943 220.471V247.871C423.943 250.171 422.043 252.071 419.743 252.071Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384.943 225.971H364.143C363.343 225.971 362.643 225.271 362.643 224.471C362.643 223.671 363.343 222.971 364.143 222.971H384.943C385.743 222.971 386.443 223.671 386.443 224.471C386.443 225.271 385.843 225.971 384.943 225.971Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.743 297.971H329.543C327.243 297.971 325.343 296.071 325.343 293.771V266.371C325.343 264.071 327.243 262.171 329.543 262.171H419.743C422.043 262.171 423.943 264.071 423.943 266.371V293.771C423.943 296.071 422.043 297.971 419.743 297.971Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384.943 271.771H364.143C363.343 271.771 362.643 271.071 362.643 270.271C362.643 269.471 363.343 268.771 364.143 268.771H384.943C385.743 268.771 386.443 269.471 386.443 270.271C386.443 271.071 385.843 271.771 384.943 271.771Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.743 252.071H214.543C212.243 252.071 210.343 250.171 210.343 247.871V220.471C210.343 218.171 212.243 216.271 214.543 216.271H304.743C307.043 216.271 308.943 218.171 308.943 220.471V247.871C308.943 250.171 307.043 252.071 304.743 252.071Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.043 225.971H249.243C248.443 225.971 247.743 225.271 247.743 224.471C247.743 223.671 248.443 222.971 249.243 222.971H270.043C270.843 222.971 271.543 223.671 271.543 224.471C271.543 225.271 270.843 225.971 270.043 225.971Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.743 297.971H214.543C212.243 297.971 210.343 296.071 210.343 293.771V266.371C210.343 264.071 212.243 262.171 214.543 262.171H304.743C307.043 262.171 308.943 264.071 308.943 266.371V293.771C308.943 296.071 307.043 297.971 304.743 297.971Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.043 271.771H249.243C248.443 271.771 247.743 271.071 247.743 270.271C247.743 269.471 248.443 268.771 249.243 268.771H270.043C270.843 268.771 271.543 269.471 271.543 270.271C271.543 271.071 270.843 271.771 270.043 271.771Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.743 342.771H329.543C327.243 342.771 325.343 340.871 325.343 338.571V311.171C325.343 308.871 327.243 306.971 329.543 306.971H419.743C422.043 306.971 423.943 308.871 423.943 311.171V338.571C423.943 340.871 422.043 342.771 419.743 342.771Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384.943 316.671H364.143C363.343 316.671 362.643 315.971 362.643 315.171C362.643 314.371 363.343 313.671 364.143 313.671H384.943C385.743 313.671 386.443 314.371 386.443 315.171C386.443 315.971 385.843 316.671 384.943 316.671Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.743 342.771H214.543C212.243 342.771 210.343 340.871 210.343 338.571V311.171C210.343 308.871 212.243 306.971 214.543 306.971H304.743C307.043 306.971 308.943 308.871 308.943 311.171V338.571C308.943 340.871 307.043 342.771 304.743 342.771Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270.043 316.671H249.243C248.443 316.671 247.743 315.971 247.743 315.171C247.743 314.371 248.443 313.671 249.243 313.671H270.043C270.843 313.671 271.543 314.371 271.543 315.171C271.543 315.971 270.843 316.671 270.043 316.671Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710.443 235.471H550.543C548.043 235.471 545.943 233.371 545.943 230.871V151.171C545.943 148.671 548.043 146.571 550.543 146.571H710.443C712.943 146.571 715.043 148.671 715.043 151.171V230.871C715.043 233.471 713.043 235.471 710.443 235.471Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710.443 334.471H550.543C548.043 334.471 545.943 332.371 545.943 329.871V250.171C545.943 247.671 548.043 245.571 550.543 245.571H710.443C712.943 245.571 715.043 247.671 715.043 250.171V329.871C715.043 332.371 713.043 334.471 710.443 334.471Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M586.543 185.171H576.643V235.471H586.543V185.171Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596.743 198.971H586.443V235.571H596.743V198.971Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.2425 72.871H39.3425V123.171H49.2425V72.871Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.4426 86.571H49.1426V123.171H59.4426V86.571Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.0426 93.771H19.1426V123.171H29.0426V93.771Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.3425 64.271H29.0425V123.071H39.3425V64.271Z",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580.343 290.771L581.443 275.871C581.543 274.871 580.743 274.071 579.743 274.071H575.543H571.243C570.243 274.071 569.543 274.871 569.543 275.871L570.642 290.771C570.642 290.771 561.643 296.571 561.743 301.371C561.843 305.071 564.043 322.771 565.043 330.571C565.343 332.771 567.143 334.371 569.343 334.371H575.543H581.743C583.943 334.371 585.743 332.771 586.043 330.571C587.043 322.771 589.243 305.071 589.343 301.371C589.343 296.571 580.343 290.771 580.343 290.771Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M628.543 191.871L629.643 176.971C629.743 175.971 628.943 175.171 627.943 175.171H623.643H619.343C618.343 175.171 617.643 175.971 617.643 176.971L618.743 191.871C618.743 191.871 609.743 197.671 609.843 202.471C609.943 206.171 612.143 223.871 613.143 231.671C613.443 233.871 615.243 235.471 617.443 235.471H623.643H629.843C632.043 235.471 633.843 233.871 634.143 231.671C635.143 223.871 637.343 206.171 637.443 202.471C637.543 197.671 628.543 191.871 628.543 191.871Z",
  fill: "#77A1E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.94263 372.071L708.943 379.771",
  stroke: "#77A1E3",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M344.243 71.1711L500.843 54.9711C503.743 54.6711 506.143 57.0711 505.943 59.9711L492.543 212.371C492.243 216.171 488.943 218.971 485.243 218.771L333.143 210.571C330.543 210.471 328.643 208.171 328.743 205.671L337.943 77.7711C338.243 74.2711 340.843 71.5711 344.243 71.1711Z",
  fill: "#F8AB5D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M338.543 69.471L496.943 53.071C499.843 52.771 502.343 55.171 502.043 58.171L488.543 212.271C488.243 216.071 484.943 218.971 481.143 218.671L327.243 210.371C324.643 210.271 322.643 207.971 322.843 205.371L332.143 75.971C332.543 72.571 335.143 69.871 338.543 69.471Z",
  fill: "#1D62D1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M160.843 449.271C160.443 450.571 159.543 455.771 158.843 460.571C146.943 462.571 136.743 457.871 136.743 457.871C137.243 452.871 137.743 447.671 137.743 447.671C137.743 444.871 161.643 446.871 160.843 449.271Z",
  fill: "#22272E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M158.843 460.471C158.243 464.671 157.643 468.371 157.643 468.371C157.643 468.371 154.943 474.671 148.143 474.671C141.243 474.671 135.843 468.971 135.943 466.571C136.043 465.471 136.343 461.671 136.743 457.771C136.743 457.771 146.843 462.471 158.843 460.471Z",
  fill: "#F7D4D9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M136.043 464.671C136.043 464.671 137.943 466.771 139.143 467.771C140.243 468.771 143.643 465.671 148.443 466.271C153.243 466.871 154.743 468.771 154.743 468.771C154.743 468.771 156.743 468.371 157.843 467.471C157.843 467.471 157.843 470.871 159.343 474.771C160.843 478.671 168.443 490.071 168.443 492.271C168.443 494.471 167.943 496.171 166.343 496.871C164.743 497.571 154.143 497.671 145.243 497.871C136.343 498.071 129.443 498.571 128.443 495.071C127.443 491.571 131.543 480.671 133.243 473.971C134.943 467.171 134.643 464.771 136.043 464.671Z",
  fill: "#22272E"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M137.543 483.171C137.543 483.171 148.243 477.471 158.443 483.171",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M139.543 477.571C139.543 477.571 147.843 474.871 156.543 477.571",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M264.643 456.171C253.243 460.071 241.443 457.671 241.543 457.771C241.143 452.171 240.643 446.271 240.643 446.271C242.143 442.771 263.643 441.171 263.843 442.671C263.843 443.471 264.243 450.071 264.643 456.171Z",
  fill: "#22272E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M265.243 466.771C265.243 466.771 263.743 471.471 257.243 473.871C250.743 476.271 242.443 469.771 242.343 467.871C242.243 467.071 241.943 462.471 241.543 457.771C241.543 457.671 253.243 460.071 264.643 456.171C264.943 461.671 265.243 466.771 265.243 466.771Z",
  fill: "#F7D4D9"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M242.143 466.471C241.443 466.471 240.943 467.471 240.543 473.771C240.143 480.071 238.143 493.971 240.543 496.071C242.943 498.171 290.843 497.571 296.343 497.171C301.843 496.771 304.843 493.171 303.143 490.771C301.443 488.371 289.643 483.971 279.243 476.971C268.843 469.971 266.343 468.471 265.143 466.771C265.143 466.771 265.743 461.071 262.643 461.971C259.543 462.871 257.443 470.271 253.443 471.271C249.543 472.171 248.943 466.071 242.143 466.471Z",
  fill: "#22272E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M281.543 477.171C281.543 477.171 278.843 476.371 272.743 482.871",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M274.943 472.871C274.943 472.871 270.143 472.671 264.643 479.771",
  stroke: "white",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M140.543 459.171L141.143 455.171",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M147.443 460.671L148.043 456.671",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M155.043 460.971L155.743 457.371",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M246.043 458.271L245.743 454.071",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M254.343 458.171L254.043 453.571",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M261.843 456.971L261.543 452.671",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M133.843 225.371C133.843 225.371 131.343 235.671 131.043 249.371C130.743 263.071 141.443 305.971 145.343 320.471C149.243 335.071 148.443 337.271 147.843 340.071C147.243 342.871 141.243 365.071 139.243 388.071C137.243 411.071 130.043 429.571 130.843 436.671C131.943 446.271 136.043 449.071 137.743 450.171C139.443 451.271 153.443 455.771 162.943 453.571C162.943 453.571 173.043 447.171 174.943 438.171C176.943 429.171 175.743 418.271 182.243 388.871C188.643 359.471 191.743 347.371 192.643 335.671C193.143 328.671 193.243 308.671 193.343 293.371C193.443 282.971 193.443 274.671 193.543 273.871C193.843 271.871 198.743 274.171 201.343 267.771C202.443 264.871 203.043 259.371 203.143 253.471C203.343 245.971 202.843 237.771 201.843 233.271C200.243 224.971 135.443 216.571 133.843 225.371Z",
  fill: "#22272E"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M271.043 438.471C269.343 442.671 266.243 447.471 263.443 448.571C260.643 449.671 248.043 451.371 241.643 450.771C241.643 450.771 230.943 447.671 229.843 439.571C228.743 431.471 230.643 422.471 227.043 404.271C223.443 386.071 220.343 353.871 219.443 344.371C218.643 334.871 198.943 306.571 189.743 289.471C180.543 272.371 170.643 241.071 178.843 233.771C187.043 226.371 216.343 223.171 225.043 229.071C225.043 229.071 235.143 253.671 245.243 283.071C254.543 310.071 256.443 319.171 257.743 326.971C257.843 327.671 257.943 328.371 258.143 329.071C258.543 331.471 259.043 337.671 259.743 345.671C261.343 365.971 263.243 397.471 264.043 404.671C265.143 414.671 272.743 434.271 271.043 438.471Z",
  fill: "#22272E"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M187.943 275.371C187.943 275.371 198.543 271.471 207.943 269.971",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M186.117 344.985C187.562 337.727 182.937 330.689 175.787 329.266C168.636 327.843 161.669 332.573 160.224 339.832C158.78 347.09 163.405 354.128 170.555 355.551C177.705 356.974 184.673 352.244 186.117 344.985Z",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M259.743 345.571C257.343 348.571 253.643 350.471 249.543 350.471C242.243 350.471 236.343 344.571 236.343 337.171C236.343 329.871 242.243 323.871 249.443 323.871C252.543 323.871 255.443 324.971 257.743 326.871",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M136.143 272.671C136.143 272.671 147.243 263.671 147.343 247.071C147.343 247.071 140.343 246.671 136.143 245.671",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M193.343 293.371C193.443 282.971 193.443 274.671 193.543 273.871C193.843 271.871 198.743 274.171 201.343 267.771C202.443 264.871 203.043 259.371 203.143 253.471",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M222.843 110.871C222.843 110.871 231.043 111.271 244.243 137.671C257.443 163.971 262.143 173.571 262.143 173.571C262.143 173.571 270.843 171.471 285.043 169.171C299.243 166.871 319.243 163.971 319.243 163.971C319.243 163.971 324.643 164.071 326.943 171.771C328.543 177.371 326.043 181.371 324.543 183.171C324.043 183.771 323.443 184.271 322.643 184.571C316.543 187.171 280.943 202.171 268.843 204.771C255.543 207.571 249.043 207.171 237.243 190.971C225.443 174.771 216.143 162.171 211.843 155.671C207.543 148.871 204.443 111.871 222.843 110.871Z",
  fill: "#F6AE2D"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M245.343 200.171C245.343 200.171 244.643 194.871 254.943 194.871C265.243 194.871 270.543 202.571 268.043 204.771",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M262.143 173.471C262.143 173.471 257.843 175.471 256.943 178.471",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M319.743 164.771C319.743 164.771 324.143 163.171 325.243 162.571C326.343 161.971 328.743 157.771 330.743 155.171C332.743 152.571 338.443 151.071 340.043 151.371C341.643 151.671 342.243 152.671 342.243 152.671C342.243 152.671 347.243 150.871 350.643 149.471C354.043 148.071 360.343 144.971 361.243 147.471C361.743 148.971 357.843 151.171 355.143 152.671C351.843 154.571 349.643 155.971 349.643 155.971C349.643 155.971 351.243 156.771 351.643 158.871C352.043 160.971 353.143 163.271 351.143 166.471C350.543 167.371 352.843 169.871 351.043 172.171C347.943 175.871 340.443 177.771 336.443 178.971C332.343 180.171 323.043 180.771 323.043 180.771C323.043 180.771 320.043 180.071 318.743 173.571C317.443 167.071 319.743 164.771 319.743 164.771Z",
  fill: "#F7D4D9"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M342.243 152.671C342.243 152.671 342.943 154.471 343.743 157.171C344.543 159.871 345.143 161.971 343.043 162.071C340.943 162.171 339.043 158.971 338.243 157.371",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M339.643 159.671C339.643 159.671 341.943 164.271 336.643 168.271",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M349.743 155.971L344.143 158.571",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M341.343 161.471C341.343 161.471 340.343 163.071 341.343 163.971C342.343 164.871 347.843 162.871 351.843 160.571",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M342.242 164.171C342.242 164.171 340.542 165.071 341.342 166.871C342.142 168.671 346.442 167.971 351.142 166.471",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M343.143 167.971C343.143 167.971 340.643 168.271 341.943 170.771C342.743 172.271 347.543 171.771 348.543 172.171",
  stroke: "#E26E85",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M313.942 165.671C313.142 167.071 312.142 169.771 312.842 174.571C313.642 180.671 317.143 183.671 319.043 184.871",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M190.443 74.271C190.443 74.271 187.243 90.371 185.443 94.771C183.643 99.171 193.443 106.071 203.243 106.471C213.043 106.871 212.043 101.171 212.043 101.171L214.943 85.171C214.943 85.271 193.943 70.571 190.443 74.271Z",
  fill: "#F7D4D9"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M194.843 79.071C193.443 91.271 202.243 97.171 212.043 101.771C212.043 101.471 212.043 101.171 212.043 101.171L213.643 92.671C206.343 90.271 199.943 85.071 194.843 79.071Z",
  fill: "#E26E85"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M148.443 106.571C150.643 100.071 159.043 96.171 165.843 96.771C172.843 97.371 186.243 97.571 199.143 101.571C221.143 108.371 226.443 112.371 227.743 113.571C235.043 120.571 234.343 130.971 230.143 159.671C227.443 178.571 225.143 183.371 225.743 192.671C226.343 201.871 228.043 218.471 229.143 221.871C230.243 225.271 227.443 231.171 225.043 233.271C222.643 235.371 203.243 239.771 185.243 239.371C167.343 238.971 138.943 234.071 134.443 231.071C129.943 228.071 126.743 222.871 127.743 218.371C128.643 213.871 129.743 207.471 132.543 197.971C135.343 188.471 135.543 176.071 139.943 156.171C143.343 141.471 143.843 120.171 148.443 106.571Z",
  fill: "#1D62D1"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M175.943 179.871C181.543 181.071 194.343 183.471 209.743 183.771C211.243 183.771 212.543 184.971 212.743 186.471C213.043 189.071 214.243 193.271 217.843 197.271C218.343 197.771 218.643 198.471 218.643 199.271C218.743 203.471 218.943 217.671 216.143 219.871C212.943 222.271 178.943 224.471 157.843 218.571C156.443 218.171 155.443 216.971 155.443 215.571C155.543 211.471 155.743 202.871 156.443 197.471C156.643 196.371 157.343 195.471 158.343 194.971C161.643 193.471 169.243 189.471 171.943 181.971C172.743 180.371 174.343 179.471 175.943 179.871Z",
  stroke: "#F8AB5D",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M184.143 92.371C184.543 91.371 185.843 91.171 186.643 91.871C188.543 93.871 192.643 96.871 200.043 98.271C211.343 100.371 212.443 98.671 212.443 98.671C212.443 98.671 214.243 99.271 214.443 100.771C214.643 102.271 214.143 106.071 213.643 107.971C213.043 109.871 204.643 110.071 197.943 108.671C191.743 107.371 186.243 104.671 182.243 100.571C181.543 99.871 181.343 98.871 181.743 97.971C182.343 96.471 183.343 94.271 184.143 92.371Z",
  fill: "#F6AE2D"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M233.443 55.271C233.443 57.271 233.443 62.671 231.443 67.871C229.443 73.071 226.143 87.571 219.643 92.271C213.143 96.971 198.943 96.071 192.743 83.971C186.543 71.971 188.543 59.171 191.743 48.971C194.943 38.771 208.143 35.071 219.643 39.271C231.243 43.471 233.443 50.771 233.443 55.271Z",
  fill: "#F7D4D9"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M191.443 62.271C191.443 62.271 192.143 63.071 193.143 65.171C194.043 67.271 195.943 66.071 196.643 62.271C197.343 58.471 198.943 55.771 200.143 55.971C201.343 56.271 205.543 56.771 208.043 52.271C210.543 47.671 211.643 48.371 211.643 48.371C211.643 48.371 213.643 43.571 218.843 50.471C224.043 57.371 227.343 62.771 233.543 61.671C239.743 60.571 245.243 50.471 240.543 40.771C235.743 31.071 221.043 28.771 210.043 31.671C199.043 34.571 193.343 32.171 186.743 37.771C180.143 43.371 181.743 49.271 181.343 55.871C180.943 62.471 177.543 65.971 182.043 71.871C186.543 77.771 185.343 83.271 187.843 86.571C187.843 86.571 190.543 77.871 190.243 71.571C189.943 65.271 191.443 62.271 191.443 62.271Z",
  fill: "#22272E"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M221.143 67.7711C220.943 73.0711 216.643 77.2711 211.543 77.2711C206.343 77.2711 202.143 72.9711 202.243 67.5711C202.243 62.0711 206.743 57.5711 212.043 57.6711C217.343 57.7711 221.343 62.3711 221.143 67.7711Z",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M236.549 73.6806C237.939 68.9084 236.357 64.2511 233.017 63.2783C229.676 62.3054 225.841 65.3854 224.452 70.1577C223.062 74.9299 224.643 79.5872 227.984 80.5601C231.325 81.5329 235.159 78.4529 236.549 73.6806Z",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M224.643 69.871C224.643 69.871 224.543 67.871 221.043 68.971",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M203.043 63.4711L191.443 61.3711",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M192.443 64.071C192.443 64.071 191.543 58.771 187.243 58.671C182.943 58.671 180.343 71.771 191.043 73.571",
  fill: "#F7D4D9"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M186.543 62.771C187.443 62.571 188.543 62.771 189.243 63.771C189.543 64.271 189.643 64.871 189.643 65.471C189.643 65.771 189.543 65.971 189.543 66.271C189.543 66.471 189.443 66.671 189.443 66.871C189.343 67.271 189.343 67.571 189.343 67.871C189.343 68.171 189.343 68.371 189.543 68.571C189.843 69.071 190.643 69.471 191.443 69.971C190.543 70.171 189.543 70.371 188.543 69.671C188.043 69.371 187.743 68.671 187.643 68.171C187.543 67.571 187.643 67.071 187.743 66.571C187.843 66.371 187.843 66.071 187.943 65.871C187.943 65.671 188.043 65.571 188.043 65.371C188.143 65.071 188.143 64.771 188.043 64.571C187.943 63.871 187.343 63.271 186.543 62.771Z",
  fill: "#22272E"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M223.243 68.271C223.343 69.471 223.543 70.571 223.943 71.571C224.143 72.071 224.343 72.471 224.643 72.871C224.843 73.171 225.443 73.871 225.543 74.571C225.943 76.071 225.443 77.471 224.743 78.471C224.343 78.971 223.943 79.471 223.343 79.771C222.843 80.071 222.143 80.371 221.543 80.271C222.543 79.571 223.043 78.671 223.443 77.671C223.843 76.771 223.943 75.771 223.743 74.971C223.643 74.571 223.443 74.371 223.043 73.671C222.743 73.071 222.543 72.471 222.443 71.771C222.443 70.571 222.643 69.271 223.243 68.271Z",
  fill: "#22272E"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M213.243 84.171C213.243 84.171 208.843 84.271 206.643 79.771",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M209.143 69.671C208.343 69.471 207.843 68.671 208.043 67.871L208.443 66.371C208.643 65.571 209.443 65.071 210.243 65.271C211.043 65.471 211.543 66.271 211.343 67.071L210.943 68.571C210.743 69.371 209.943 69.871 209.143 69.671Z",
  fill: "#22272E"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M225.043 73.771C224.243 73.571 223.743 72.771 223.943 71.971L224.343 70.471C224.543 69.671 225.343 69.171 226.143 69.371C226.943 69.571 227.443 70.371 227.243 71.171L226.843 72.671C226.643 73.471 225.843 73.971 225.043 73.771Z",
  fill: "#22272E"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M213.143 62.771C212.043 62.971 211.543 61.471 209.943 61.571C207.443 61.671 206.043 62.171 205.843 61.071C205.743 60.271 207.643 58.771 210.043 58.671C213.543 58.671 215.143 62.471 213.143 62.771Z",
  fill: "#22272E"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M225.043 65.771C225.743 66.371 226.743 65.271 227.743 65.971C229.243 66.871 229.743 67.671 230.243 66.971C230.643 66.371 230.243 64.571 228.843 63.671C226.543 62.071 223.543 64.671 225.043 65.771Z",
  fill: "#22272E"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M99.0427 232.971C99.0427 232.971 97.7427 235.771 97.7427 237.471C97.7427 239.171 99.1427 254.871 98.7427 257.971C98.2427 261.071 97.3427 267.171 96.7427 268.071C96.1427 268.971 92.5427 266.171 92.4427 256.771C92.3427 247.371 89.1427 234.471 91.8427 232.971C94.5427 231.471 98.2427 231.771 99.0427 232.971Z",
  fill: "#F7D4D9"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5426 279.371L57.5426 241.571C58.6426 239.871 60.9426 239.271 62.7426 240.471L119.243 276.371C120.943 277.471 121.543 279.771 120.343 281.571L96.3426 319.371C95.2426 321.071 92.9426 321.671 91.1426 320.471L34.6426 284.571C32.9426 283.471 32.4426 281.171 33.5426 279.371Z",
  fill: "#22272E"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8426 308.271L111.843 289.471C112.343 288.571 113.643 288.571 114.243 289.371L116.143 291.871C116.543 292.371 116.543 292.971 116.243 293.571L105.443 310.571C105.143 311.071 104.543 311.371 103.943 311.171L100.843 310.571C99.8426 310.271 99.3426 309.171 99.8426 308.271Z",
  fill: "#F6AE2D"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3425 231.971C96.3425 231.971 95.7425 249.371 95.6425 253.071C95.5425 256.671 95.7425 264.071 94.8425 267.571C93.9425 271.071 92.4425 279.871 89.7425 280.471C87.0425 281.071 89.9425 269.671 89.9425 267.471C89.9425 265.271 88.7425 259.971 88.7425 259.971C88.7425 259.971 87.7425 265.471 87.0425 267.871C86.3425 270.271 81.7425 277.771 79.9425 277.471C78.0425 277.171 80.3425 271.571 81.7425 268.171C83.0425 265.071 83.5425 258.571 83.5425 258.571C83.5425 258.571 82.0425 262.371 80.8425 264.371C79.6425 266.371 75.5425 272.571 73.8425 272.271C72.0425 271.971 74.9425 265.671 76.6425 262.771C78.3425 259.871 78.4425 257.771 78.4425 257.771C78.4425 257.771 75.7425 260.471 74.0425 261.771C72.3425 263.071 66.3425 265.971 65.8425 264.471C65.4425 262.971 68.0425 261.371 70.5425 259.071C73.0425 256.871 75.7425 252.171 76.3425 251.371C76.9425 250.671 75.2425 243.571 77.9425 238.871C80.6425 234.171 82.2425 232.271 82.9425 229.071C83.5425 225.971 96.0425 229.671 96.3425 231.971Z",
  fill: "#F7D4D9"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M158.843 96.771C158.843 96.771 147.443 95.671 133.743 112.871C120.043 130.071 106.543 144.471 102.743 151.271C98.9426 158.171 90.5425 183.571 86.3425 203.671C82.1425 223.771 81.7425 227.371 81.8425 229.571C81.9425 231.571 92.0426 234.371 98.6426 234.271C99.8426 234.271 100.943 233.571 101.343 232.471C103.943 226.371 113.043 205.571 116.643 197.971C120.843 189.071 125.743 175.871 126.343 174.971C126.943 174.071 154.243 146.271 159.343 138.971C164.443 131.771 169.343 119.871 168.243 109.471C167.043 98.171 161.243 96.671 158.843 96.771Z",
  fill: "#F6AE2D"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M104.143 148.971C104.143 148.971 107.243 144.671 111.143 148.571C115.243 152.671 113.443 161.571 107.743 167.171C103.043 171.771 96.3427 169.871 96.9427 165.571",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M83.2427 224.771C85.9427 226.071 94.0427 229.671 101.943 228.671",
  stroke: "#22272E",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M345.043 253.171L361.843 198.171C362.343 196.671 363.743 195.671 365.343 195.671L464.743 198.471C466.443 198.471 467.543 200.071 467.143 201.671L447.643 268.771C447.143 270.471 445.443 271.571 443.743 271.271L347.243 256.371C345.543 256.171 344.543 254.671 345.043 253.171Z",
  fill: "#22272E"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M344.143 255.971L286.343 261.371L385.443 285.771C387.843 286.371 390.343 286.371 392.743 285.771L446.543 271.871L344.143 255.971Z",
  fill: "#63737A"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M385.543 285.771L286.443 261.371C286.443 263.271 287.743 264.871 289.543 265.371L382.943 290.171C386.843 291.171 391.043 291.171 394.943 289.971L443.943 275.571C445.643 275.071 446.743 273.571 446.743 271.771L392.943 285.671C390.343 286.371 387.843 286.371 385.543 285.771Z",
  fill: "#22272E"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M410.342 207.871L403.342 231.671C403.142 232.271 402.542 232.671 401.942 232.671L362.642 229.271C361.742 229.171 361.242 228.371 361.442 227.571L368.042 205.771C368.242 205.171 368.742 204.771 369.342 204.771L409.042 206.171C409.942 206.171 410.542 207.071 410.342 207.871Z",
  fill: "white"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M402.842 212.171L398.442 226.471L367.842 224.271L368.942 221.071L380.242 216.071L386.642 221.071L402.842 212.171Z",
  fill: "#F7D4D9"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M379.942 241.371L377.042 250.371C376.842 250.971 376.242 251.371 375.542 251.271L356.642 248.771C355.842 248.671 355.242 247.871 355.542 247.071L358.042 238.671C358.242 238.071 358.842 237.671 359.442 237.671L378.742 239.671C379.642 239.671 380.242 240.471 379.942 241.371Z",
  fill: "#1D62D1"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M409.542 244.371L406.342 254.271C406.142 254.871 405.542 255.271 404.842 255.171L386.842 252.771C386.042 252.671 385.442 251.871 385.742 250.971L388.742 241.671C388.942 241.071 389.542 240.671 390.142 240.771L408.342 242.571C409.242 242.671 409.842 243.471 409.542 244.371Z",
  fill: "#F6AE2D"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M443.543 247.771L440.143 258.771C439.943 259.371 439.343 259.771 438.643 259.671L416.943 256.771C416.143 256.671 415.543 255.871 415.843 254.971L419.143 244.671C419.343 244.071 419.943 243.671 420.543 243.771L442.243 245.971C443.243 246.071 443.843 246.971 443.543 247.771Z",
  fill: "#F7D4D9"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M431.842 212.671C431.142 215.671 428.042 217.971 425.042 217.771C422.142 217.571 420.642 215.071 421.442 212.271C422.242 209.571 425.042 207.571 427.742 207.571C430.542 207.571 432.442 209.871 431.842 212.671Z",
  fill: "#1D62D1"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M438.943 209.371L453.543 209.871",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M416.143 228.371L447.443 230.571",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M437.243 215.271L451.843 215.871",
  stroke: "#63737A",
  strokeWidth: 1.8,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M447.081 120.859C446.907 122.595 445.35 124.21 443.814 125.803C442.576 127.088 441.351 128.358 440.874 129.668C440.371 131.048 440.559 132.687 440.745 134.317C440.969 136.275 441.192 138.221 440.217 139.694C439.222 141.199 437.205 141.929 435.193 142.657C433.54 143.256 431.889 143.854 430.813 144.879C429.736 145.904 429.061 147.52 428.384 149.139L428.384 149.139C428.302 149.334 428.221 149.528 428.139 149.722L439.013 170.617L423.015 171.388L413.567 184.186L405.233 167.46L393.465 185.243L386.501 173.274L370.488 174.189L385.673 151.896C385.634 151.73 385.596 151.562 385.558 151.395C385.199 149.829 384.842 148.267 383.96 147.345C383.078 146.422 381.531 145.992 379.981 145.562C378.095 145.039 376.205 144.514 375.502 143.1C374.813 141.713 375.431 139.721 376.052 137.717C376.569 136.05 377.088 134.376 376.86 133.037C376.642 131.763 375.66 130.609 374.667 129.442C373.436 127.994 372.189 126.527 372.363 124.79C372.537 123.053 374.094 121.438 375.631 119.844C376.868 118.56 378.093 117.29 378.57 115.981C379.072 114.601 378.884 112.963 378.698 111.333C378.474 109.374 378.251 107.427 379.227 105.953C380.222 104.45 382.238 103.719 384.25 102.991C385.904 102.392 387.555 101.794 388.631 100.768C389.708 99.7435 390.384 98.1273 391.061 96.5078L391.061 96.5078C391.885 94.5372 392.711 92.5616 394.263 91.6409C395.785 90.7374 397.726 91.0506 399.677 91.3657C401.3 91.6277 402.93 91.891 404.334 91.4558C405.667 91.0428 406.996 89.8824 408.34 88.7091C410.008 87.2533 411.698 85.7778 413.446 85.6858C415.194 85.5938 416.604 86.9062 417.996 88.201C419.118 89.2445 420.227 90.2767 421.491 90.5529C422.823 90.8451 424.525 90.4061 426.218 89.9692C428.253 89.4445 430.275 88.9227 431.631 89.6745C433.015 90.4415 433.451 92.3509 433.886 94.2553C434.244 95.8206 434.601 97.3826 435.483 98.3043C436.365 99.2258 437.911 99.655 439.462 100.085C441.348 100.608 443.239 101.133 443.942 102.548C444.63 103.935 444.013 105.928 443.392 107.931C442.875 109.598 442.356 111.272 442.584 112.612C442.802 113.884 443.784 115.039 444.776 116.206C446.007 117.654 447.255 119.122 447.081 120.859Z",
  fill: "#22272E"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M396.829 130.459L417.823 143.286L391.416 183.192L384.452 171.222L368.439 172.137L396.829 130.459Z",
  fill: "#4F4F4F"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M416.665 129.56L392.866 144.704L411.519 182.134L420.966 169.336L436.965 168.565L416.665 129.56Z",
  fill: "#63737A"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M445.032 118.807C444.717 121.944 439.894 124.682 438.825 127.616C437.719 130.653 439.955 134.942 438.168 137.642C436.354 140.384 431.15 140.555 428.764 142.828C426.377 145.1 425.96 150.277 423.13 151.956C420.343 153.612 416.152 151.183 413.061 152.14C410.073 153.067 407.106 157.744 403.949 157.91C400.792 158.076 398.736 153.663 395.904 153.043C392.972 152.401 388.247 155.299 385.764 153.923C383.243 152.525 383.866 147.336 381.911 145.293C379.957 143.248 374.734 143.625 373.453 141.048C372.19 138.508 375.314 133.935 374.811 130.985C374.322 128.132 370 125.875 370.314 122.739C370.629 119.602 375.452 116.862 376.521 113.929C377.626 110.892 375.39 106.602 377.178 103.901C378.992 101.162 384.196 100.989 386.583 98.7164C388.969 96.4451 389.386 91.2666 392.214 89.5892C395.003 87.934 399.194 90.3625 402.285 89.4041C405.272 88.4788 408.24 83.8002 411.397 83.6341C414.554 83.468 416.61 87.8822 419.442 88.5012C422.374 89.1443 427.098 86.2451 429.582 87.6229C432.102 89.0203 431.48 94.2096 433.434 96.2526C435.389 98.2954 440.612 97.919 441.893 100.496C443.154 103.037 440.032 107.61 440.535 110.561C441.024 113.412 445.346 115.67 445.032 118.807Z",
  fill: "#F6AE2D"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M410.311 94.4661C395.696 95.2352 382.667 107.636 381.21 122.165C379.754 136.694 390.42 147.848 405.035 147.079C419.65 146.31 432.679 133.909 434.136 119.38C435.592 104.851 424.926 93.6971 410.311 94.4661ZM405.346 143.984C392.451 144.663 383.038 134.82 384.324 122.001C385.609 109.182 397.105 98.2396 410 97.561C422.895 96.8825 432.308 106.725 431.022 119.544C429.737 132.363 418.241 143.306 405.346 143.984ZM420.406 116.396C420.25 115.81 419.741 115.401 419.084 115.342L412.697 114.754L410.444 109.278C410.207 108.702 409.612 108.358 408.914 108.395C408.217 108.431 407.545 108.842 407.189 109.449L403.807 115.222L397.232 116.492C396.557 116.623 395.96 117.09 395.686 117.697C395.41 118.309 395.508 118.959 395.933 119.386L400.225 123.697L398.49 130.084C398.314 130.726 398.536 131.351 399.062 131.694C399.351 131.882 399.705 131.965 400.068 131.946C400.365 131.931 400.673 131.845 400.959 131.692L406.901 128.47L412.258 131.1C412.517 131.225 412.809 131.279 413.107 131.263C413.47 131.244 413.845 131.123 414.175 130.902C414.774 130.5 415.125 129.844 415.078 129.214L414.611 122.943L419.819 118.133C420.333 117.653 420.559 116.985 420.406 116.396Z",
  fill: "#FCE29C"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M613.469 84.0022L476.183 96.1281C472.599 96.4821 469.673 93.381 470.024 89.8473L476.038 31.7776C476.403 28.4435 478.927 25.8588 482.198 25.3265L617.216 6.64449C621.783 6.02038 625.863 9.84177 625.39 14.4868L619.829 77.537C619.77 80.9497 616.961 83.755 613.469 84.0022Z",
  fill: "#F8AB5D"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M605.657 78.4401L468.371 90.5659C464.787 90.9199 461.861 87.8188 462.212 84.2852L468.226 26.2155C468.591 22.8814 471.115 20.2967 474.386 19.7644L609.403 1.08236C613.971 0.458244 618.051 4.27965 617.578 8.92466L612.017 71.9748C611.858 75.3946 609.148 78.1929 605.657 78.4401Z",
  fill: "#22272E"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M500.74 42.2593C500.331 46.3985 496.988 50.144 493.311 50.6048C489.634 51.0656 487.014 48.0431 487.423 43.9039C487.832 39.7647 491.175 36.0192 494.852 35.5584C498.529 35.0976 501.149 38.1201 500.74 42.2593Z",
  fill: "#1D62D1"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M500.004 68.6772L483.68 70.3342C481.493 70.5893 479.556 68.7214 479.8 66.4987L479.972 64.682C480.746 57.2087 486.685 50.4724 493.354 49.7998C500.016 49.0273 504.922 54.5948 504.155 62.1679L503.939 64.7896C503.681 66.8129 502.092 68.4292 500.004 68.6772Z",
  fill: "#1D62D1"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M587.872 36.7922L522.947 44.3964C521.557 44.595 520.368 43.3759 520.575 42.058L520.963 37.6195C521.156 36.1021 522.276 34.9201 523.765 34.7144L588.761 26.7042C590.151 26.5056 591.333 27.6249 591.132 29.0426L590.673 33.8871C590.58 35.3975 589.368 36.6863 587.872 36.7922Z",
  fill: "#F6AE2D"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M523.082 56.2164L524.298 59.2381L527.426 59.5179L524.923 62.4018L524.971 65.9072L522.278 64.6943L519.199 66.5163L519.95 62.9544L517.978 60.5878L521.213 59.5567L523.082 56.2164Z",
  fill: "#1D62D1"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M538.009 54.6583L539.325 57.6729L542.453 57.9527L539.95 60.8366L540.097 64.335L537.206 63.1362L534.127 64.9582L534.877 61.3963L532.898 58.9299L536.14 57.9986L538.009 54.6583Z",
  fill: "#1D62D1"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M553.328 52.9722L554.644 55.9868L557.879 56.3593L555.276 59.2503L555.431 62.8483L552.532 61.5498L549.36 63.4787L550.103 59.817L548.024 57.3577L551.459 56.3125L553.328 52.9722Z",
  fill: "#1D62D1"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M568.947 51.2649L570.27 54.3793L573.597 54.645L571.002 57.6357L571.156 61.2338L568.157 59.9423L564.886 61.8782L565.722 58.1098L563.55 55.7572L566.985 54.7121L568.947 51.2649Z",
  fill: "#1D62D1"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M584.964 49.5294L586.287 52.6437L589.721 53.0021L587.019 55.9001L587.181 59.598L584.082 58.3136L580.811 60.2495L581.647 56.481L579.468 54.0287L582.903 52.9836L584.964 49.5294Z",
  fill: "#1D62D1"
});

function SvgFinishedLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 499,
    viewBox: "0 0 676 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_421_16",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 33,
    width: 676,
    height: 368
  }, _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedLevel);
export default __webpack_public_path__ + "static/media/FinishedLevel.0ea6f71e.svg";
export { ForwardRef as ReactComponent };